export enum CandidateSortableField {
  CreatedAt = 'createdAt',
  Shortlist = 'shortlist',
  Status = 'status',
}
